module.exports = "/_next/static/images/b1795559843aff4d938d07ab4edfecfc-device-frame@2x.png.webp";